export const paginationNumber = (total: number, sizePerPage: number) => {
  if (!Number.isInteger(total / sizePerPage)) {
    return Math.ceil(total / sizePerPage);
  }
  return total / sizePerPage;
};
